export default __webpack_public_path__ + "img/manila_explores_2023-096f705eb51fd22390b95eb0ef7ee547.png";